import AuthlessA5PrintPage from "@/components/common-receipt/AuthlessA5PrintPage";
import {
  yearlyNiyaazReceiptA5Props,
  type YearlyNiyaazReceiptPrintRecord,
} from "./yearly-niyaaz-receipt-print-content";

const YearlyNiyaazReceiptPrint = () => (
  <AuthlessA5PrintPage<YearlyNiyaazReceiptPrintRecord>
    location="yearlyNiyaazReceipts"
    toProps={yearlyNiyaazReceiptA5Props}
  />
);

export default YearlyNiyaazReceiptPrint;
